import { Component } from '@angular/core';

interface WhatMakesPoint {
    label: string;
}

@Component({
    selector: 'app-what-makes',
    templateUrl: './what-makes.component.html',
    styleUrls: ['./what-makes.component.scss']
})
export class WhatMakesComponent {
    readonly insidePoints: WhatMakesPoint[] = [
        { label: 'Real nutrition calculations <br> from actual ingredients' },
        { label: 'The finest Premium <br> ingredients' },
        { label: 'Zero UPF\'s and Additives' },
        { label: 'No compromise on flavour, <br> world-class culinary team' },
        { label: '60+ rotating meals <br> for real variety' },
        { label: 'Real people <br> available to serve you' },
    ];

    readonly offMenuPoints: WhatMakesPoint[] = [
        { label: 'Estimated or generic <br> nutrition values' },
        { label: 'Lower-grade or <br> cost-cutting ingredients' },
        { label: 'Hidden processed additives <br> within sub-ingredients' },
        { label: 'Basic, mass-made meals' },
        { label: 'Same meals <br> with ingredients shuffled' },
        { label: 'Frusrating AI chatbots' }
    ];

    readonly description = 'Built on integrity, quality, and transparency <br> from sourcing to serving, in every meal.';
}
